// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__1Ovve","outerTeaseWrapper":"styles_outerTeaseWrapper__1e85n"};